angular.module('unica_social_stream.social_stream_controllers', [])

.controller('SocialStreamBasicController',
	function() {

});

